const initialState = {
    isReadingSessionSummary: false,
    sessionSummary: [],
    sessionSummaryCount: 0,

    dialerCampaignSessions: {},
    isReadingTextCampaignSessionSummary: false,
    textCampaignSessionSummary: [],
    textCampaignSessionSummaryCount: 0
}

export default initialState;

